module["exports"] = [
  "0# #### ####",
  "+61 # #### ####",
  "04## ### ###",
  "+61 4## ### ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_AU/phone_number/formats.js
// module id = 944
// module chunks = 1